<template>
<div>
  <b-row>
    <b-col>
      <router-link tag="button" :to="{ name: 'EXABAgreementsUpdate', params: { id: $route.params.id } }" class="btn btn-sm btn-default float-left mb-2">{{$t('buttons.edit')}}</router-link>
      <button type="button" class="btn btn-sm btn-warning" @click="showPreviewModal()">{{ $t('buttons.agreementPreview') }}</button>
      <router-link v-if="item.agreementOffer" :to="{name: 'EXABAgreementShow', params: {id: item.agreementOffer}}" type="button" class="btn btn-sm btn-default">{{ $t('buttons.goToAgreementOffer') }}</router-link>
      <router-link :to="{ name: 'EXABAgreementsList' }" class="btn btn-sm btn-default float-right mb-2">{{$t('buttons.backToList')}}</router-link>
    </b-col>
  </b-row>
  <Loader v-if="isLoading"></Loader>
  <b-row v-else>
    <div class="col-lg-12 mt-2 mb-4" v-if="!loadingDecision && decision && (item.type === 1 || item.status == 3 || item.status == 5)">
      <b-card>
        <h6><i class="fa fa-file fa-lg"></i>
        {{$t("views.agreements.show.offerDescriptionInformation")}}</h6>
        <hr class="mb-1 mt-0">
        <div>
            <p>{{$t('views.agreements.show.decisionUser')}}: <b>{{decision.decision}}</b><br></p>
            <p v-if="decision.signedBy">{{$t('views.agreements.show.signedBy')}}: <b>{{decision.signedBy}}</b><br></p>
            <p v-if="decision.confirmationPin">{{$t('views.agreements.show.confirmationPin')}}: <b>{{decision.confirmationPin}}</b><br></p>
            <p v-if="decision.confirmationPhone">{{$t('views.agreements.show.confirmationPhone')}}: <b><phoneNumberLink :phoneNumber="decision.confirmationPhone"/></b><br></p>
            <p v-if="decision.messageNumber">{{$t('views.agreements.show.messageNumber')}}: <b>{{decision.messageNumber}}</b><br></p>
            <p v-if="decision.sendMessageDate">{{$t('views.agreements.show.sendMessageDate')}}: <b>{{decision.sendMessageDate}}</b><br></p>
            <p v-if="decision.clientIp">{{$t('views.agreements.show.clientIp')}}: <b>{{decision.clientIp}}</b><br></p>
            <p v-if="decision.isSigned">{{$t('views.agreements.show.isSigned')}}: <b>{{decision.signedDate}}</b><br></p>
            <p v-else>{{$t('views.agreements.show.isSigned')}}: <b>{{$t('views.agreements.show.isNotSigned')}}</b></p>
            <br>
          </div>
          <div class="col-lg-12" v-if="(item.status == 3 || item.status == 5) && decision.isSigned">
            <h6>{{$t('views.agreements.show.downloadAgreementSignedCertificate')}}:</h6>
            <b-button @click="downloadAgreementSignedCertificate()" variant="success"><i class="fal fa-file-pdf"></i> {{$t('buttons.downloadPDF')}}</b-button>
          </div>
      </b-card>
    </div>
    <b-col md="12" lg="6">
      <b-card>
        <div>
          <h6 v-if="item.type === 1">
            <i class="fa fa-file fa-lg"></i>
            {{$t("views.agreements.list.types.agreementOffer")}}:
          </h6>
          <h6 v-else>
            <i class="fa fa-file fa-lg"></i>
            {{$t("views.agreements.show.agreement")}}:
          </h6>
          <hr class="mb-1 mt-0">
        </div>
        <div>
          <p v-if="item.offerDescription"><span>{{$t('views.agreements.form.offerDescription')}}</span>:
            <b>{{ item.offerDescription }}</b>
          </p>
          <p><span>{{$t('views.agreements.list.agreementNumber')}}</span>:
            <b>{{ item.number === '' ? $t('views.agreements.list.noNumber') : item.number }}</b>
          </p>
          <p v-if="item.signedDate">{{$t('views.agreements.form.signedDate')}}:
            <b>{{ $moment(item.signedDate).format('YYYY-MM-DD') }} </b>
          </p>
          <p v-if="item.dateFrom">{{$t('views.agreements.form.dateFrom')}}:
            <b>{{ $moment(item.dateFrom).format('YYYY-MM-DD') }} </b>
          </p>
          <p>{{$t('views.agreements.form.dateTo')}}:
            <b>
              <span v-if="!item.timelessAgreement"><span v-if="item.dateTo">{{ $moment(item.dateTo).format('YYYY-MM-DD') }}</span><span v-else>{{$t('null')}}</span></span>
              <span v-else>{{$t('views.agreements.form.timelessAgreement')}}</span>
            </b>
          </p>
          <p>
            {{$t('views.agreements.show.decisionClient')}}:
            <b>
              <span v-if="item.decisionUser === 0"> {{ $t('views.agreements.list.decisionUser.offer') }} </span>
              <span v-else-if="item.status == 1"> {{ $t('views.agreements.list.decisionUser.waiting') }} </span>
              <span v-else-if="item.decisionUser === 2"> {{ $t('views.agreements.list.decisionUser.rejected') }} </span>
              <span v-else-if="item.decisionUser === 3 && item.status == 3">
                  {{ $t('views.agreements.list.decisionUser.accepted') +  ' - ' + $moment(item.signedDate).format('YYYY-MM-DD HH:mm')}}
                </span>
              <span v-else-if="item.decisionUser === 5 && item.status == 3">
                  {{ $t('views.agreements.list.decisionUser.signed') +  ' - ' + $moment(item.signedDate).format('YYYY-MM-DD HH:mm')}}
                </span>
            </b>
          </p>
          <p v-if="item.basePrice"><span>{{$t('views.agreements.show.basePrice')}}</span>:
            <b>{{ item.basePrice }}</b>
          </p>
          <p v-if="item.customPrice"><span>{{$t('views.agreements.show.customPrice')}}</span>:
            <b>{{ item.customPrice }}</b>
          </p>
          <p v-if="item.advantageValue"><span>{{$t('views.agreements.show.advantageValue')}}</span>:
            <b>{{ item.advantageValue }}</b>
          </p>
          <p v-if="item.agreementTags.length > 0">
            {{$t('views.agreements.form.tags')}}:
            <span v-for="item in item.agreementTags" :key="item['@id']">
                <b-badge class="h6 mr-2">{{item.tag.tag}}</b-badge>
              </span>
          </p>
          <div v-if="item.agreementCustomFields.length > 0">
            <div v-for="(field, fieldIndex) in item.agreementCustomFields" :key="'customField_'+fieldIndex">
              <p> {{ field.customField.label }}:
                <b v-if="field.value">{{ field.value }}</b>
              </p>
            </div>
          </div>
        </div>
      </b-card>
    </b-col>
    <b-col md="12" lg="6">
      <b-card>
        <div>
          <h6>
            <i class="fa fa-user fa-lg"></i>
            {{$t("views.agreements.form.contractor")}}:
          </h6>
          <hr class="mb-1 mt-0">
        </div>
        <div>
          <p v-if="item.idClient.name" >{{$t('views.agreements.show.nameAndSurname')}}:
            <router-link v-if="item.idClient.isCompany === 0" :to="{name: 'ContractorShow', params: { id: item.idClient['@id'] }}">
              <b>{{item.idClient.fullName}}</b>
            </router-link>
            <router-link v-else :to="{name: 'FirmShow', params: { id: item.idClient['@id'] }}">
              <b>{{item.idClient.fullName}}</b>
            </router-link>
          </p>
          <p v-else-if="item.idClient.firmname1" >{{$t('views.agreements.show.firmname')}}:
            <router-link v-if="item.idClient.isCompany === 0" :to="{name: 'ContractorShow', params: { id: item.idClient['@id'] }}">
              <b>{{item.idClient.firmname1}}</b>
            </router-link>
            <router-link v-else :to="{name: 'FirmShow', params: { id: item.idClient['@id'] }}">
              <b>{{item.idClient.firmname1}}</b>
            </router-link>
          </p>
          <p v-if="item.idClient.userEmail">{{$t('views.agreements.show.email')}}:
            <b><a :href="'mailto: ' + item.idClient.userEmail">{{ item.idClient.userEmail }}</a></b>
          </p>
          <p v-if="item.idClient.contactEmail">{{$t('views.userdata.form.contactEmail')}}:
            <b><a :href="'mailto: ' + item.idClient.contactEmail">{{ item.idClient.contactEmail }}</a></b>
          </p>
          <p v-if="item.idClient.mobilePhone">{{$t('views.agreements.show.mobilePhone')}}:
            <b>
              <phoneNumberLink :phoneNumber="item.idClient.mobilePhone"/>
            </b>
          </p>
          <p v-if="item.idClient.street || item.idClient.postcode || item.idClient.city"><b>{{$t('views.agreements.show.address')}}:</b></p>
          <p v-if="item.idClient.street">{{$t('views.agreements.show.street')}}:
            <b>{{item.idClient.street}}</b>
          </p>
          <p v-if="item.idClient.postcode && item.idClient.city">{{$t('views.agreements.show.postcode')}}, {{$t('views.agreements.show.city')}}:
            <b>{{item.idClient.postcode}} {{item.idClient.city}}</b>
          </p>
          <ul v-for="(address, addressIndex) in item.agreementAddresses" :key="'address_'+addressIndex">
            <li>
              <p><b>{{ $t('views.agreements.show.address') + ' - ' + getAddressTypeText(address.idUserDataAddress.addressType) }}</b></p>
              <p v-if="address.idUserDataAddress.street">{{$t('views.agreements.show.street')}}:
                <b>{{address.idUserDataAddress.street}}</b>
              </p>
              <p v-if="address.idUserDataAddress.postcode && address.idUserDataAddress.city">{{$t('views.agreements.show.postcode')}}, {{$t('views.agreements.show.city')}}:
                <b>{{address.idUserDataAddress.postcode}} {{address.idUserDataAddress.city}}</b>
              </p>
            </li>
          </ul>
        </div>
      </b-card>
    </b-col>
    <b-col md="12" lg="12">
      <b-card v-if="item.agreementItems.length > 0">
        <div>
          <h6>
            <i class="fa fa-cog fa-lg"></i>
            {{$t('views.exsbitems.list.title')}}:
          </h6>
          <hr class="mb-1 mt-0">
        </div>
        <div>
          <table class="table table-responsive-md table-sm table-grid">
            <thead>
            <tr>
              <th style="width: 2%">
                <p>{{$t('views.exsbinvoices.form.invoicePositionHeaders.lp')}}</p>
              </th>
              <th style="width: 3%">
                <i class="fa fa-clock fa-lg" v-b-tooltip :title="$t('buttons.cyclicItem')"></i>
              </th>
              <th style="width: 3%">
                <i class="fa fa-percentage fa-lg" v-b-tooltip :title="$t('buttons.promotion')"></i>
              </th>
              <th style="width: 12%">
                <p>{{$t('views.exsbinvoices.form.invoicePositionHeaders.item')}}</p>
              </th>
              <th style="width: 10%">
                <p>{{$t('views.exsbinvoices.form.invoicePositionHeaders.valueNetto')}}</p>
              </th>
              <th style="width: 10%">
                <p>{{$t('views.exsbinvoices.form.invoicePositionHeaders.vatRate')}}</p>
              </th>
              <th style="width: 10%">
                <p>{{$t('views.exsbinvoices.form.invoicePositionHeaders.valueBrutto')}}</p>
              </th>
              <th style="width: 10%">
                <p>{{$t('views.exsbitems.list.basePrice')}}</p>
              </th>
              <th style="width: 10%">
                <p>{{$t('views.exsbitems.list.customPrice')}}</p>
              </th>
              <th style="width: 10%">
                <p>{{$t('views.exsbitems.list.advantageValue')}}</p>
              </th>
              <th style="width: 20%"></th>
            </tr>
            </thead>
            <tbody>
            <tr v-for="(item, index) in item.agreementItems" :key="item['@id']">
              <td>{{ index + 1 }}</td>
              <td>
                <b-form-checkbox
                  :checked="item.isCyclic !== 0"
                  :disabled="true">
                </b-form-checkbox>
              </td>
              <td>
                <b-form-checkbox
                  :checked="item.promotion !== null"
                  :disabled="true"
                  v-b-tooltip :title="item.promotion ? item.promotion.title : ''">
                </b-form-checkbox>
              </td>
              <td>
                <template v-if="item.item">
                  <router-link
                    v-if="ableToViewItem"
                    :to="{name: 'EXSBItemShow', params: {id: item.item['@id']}}">
                    {{ item.item.name }}
                  </router-link>
                  <span v-else>
                    {{ item.item.name }}
                  </span>
                </template>
                <template v-else-if="item.priceGroup">
                  {{ item.priceGroup.name }}
                </template>
              </td>
              <td>
                <span v-if="!item.priceUserData">
                  <span v-if="item.item">{{ item.item.priceNetto }}</span>
                </span>
                <span v-else>
                  {{ item.priceUserData.priceNetto }}
                </span>
              </td>
              <td>
                <span v-if="item.item">{{ item.item.vatRate.range }}</span>
              </td>
              <td>
                <span v-if="!item.priceUserData">
                  <span v-if="item.item">{{ item.item.priceBrutto }}</span>
                </span>
                <span v-else>
                  {{ item.priceUserData.priceBrutto }}
                </span>
              </td>
              <td><span v-if="item.basePrice">{{item.basePrice}}</span></td>
              <td><span v-if="item.customPrice">{{item.customPrice}}</span></td>
              <td><span v-if="item.advantageValue">{{item.advantageValue}}</span></td>
              <td>
                <span v-if="item.dateFrom">{{$t('global.from')}}: {{ $moment(item.dateFrom).format('YYYY-MM-DD') }} </span>
                <span v-if="item.dateTo">{{$t('global.to')}}: {{ $moment(item.dateTo).format('YYYY-MM-DD') }} </span>
              </td>
            </tr>
            </tbody>
          </table>
        </div>
        <div v-if="item.agreementPromotions.length > 0">
          <h6>
            <i class="fa fa-percent"></i>
            {{$t('views.agreements.show.promotions')}}:
          </h6>
          <hr class="mb-1 mt-0">
          <ul>
            <li v-for="item in item.agreementPromotions" :key="item['@id']">
              {{ item.promotion.title }}
            </li>
          </ul>
        </div>
        <div v-if="item.agreementDevices.length > 0">
          <h6>
            <i class="fa fa-print fa-lg"></i>
            {{$t("views.agreements.form.agreementsDevices")}}
          </h6>
          <hr class="mb-1 mt-0">
          <ul>
            <li v-for="item in item.agreementDevices" :key="item['@id']">
              <router-link
                v-if="ableToViewDevice"
                :to="{name: 'EXCMDeviceShow', params: {id: item.device['@id']}}">
                {{ item.device.name }}
              </router-link>
              <span v-else>{{ item.device.name }}</span>
            </li>
          </ul>
        </div>
      </b-card>
    </b-col>
    <b-col md="12" lg="12">
      <b-card v-if="item.agreementAdditionalItems.length > 0">
        <div>
          <h6>
            <i class="fa fa-cog fa-lg"></i>
            {{$t('views.exsbitems.list.titleAdditional')}}:
          </h6>
          <hr class="mb-1 mt-0">
        </div>
        <div>
          <table class="table table-responsive-md table-sm table-grid">
            <thead>
            <tr>
              <th style="width: 5%">
                <p>{{$t('views.exsbinvoices.form.invoicePositionHeaders.lp')}}</p>
              </th>
              <th style="width: 3%">
                <i class="fa fa-clock fa-lg" v-b-tooltip :title="$t('buttons.cyclicItem')"></i>
              </th>
              <th style="width: 5%">
                <i class="fa fa-percentage fa-lg" v-b-tooltip :title="$t('buttons.promotion')"></i>
              </th>
              <th style="width: 15%">
                <p>{{$t('views.exsbinvoices.form.invoicePositionHeaders.item')}}</p>
              </th>
              <th style="width: 15%">
                <p>{{$t('views.exsbinvoices.form.invoicePositionHeaders.valueNetto')}}</p>
              </th>
              <th style="width: 15%">
                <p>{{$t('views.exsbinvoices.form.invoicePositionHeaders.vatRate')}}</p>
              </th>
              <th style="width: 15%">
                <p>{{$t('views.exsbinvoices.form.invoicePositionHeaders.valueBrutto')}}</p>
              </th>
              <th style="width: 20%"></th>
            </tr>
            </thead>
            <tbody>
            <tr v-for="(item, index) in item.agreementAdditionalItems" :key="item['@id']">
              <td>{{ index + 1 }}</td>
              <td>
                <b-form-checkbox
                  :checked="item.isCyclic !== 0"
                  :disabled="true">
                </b-form-checkbox>
              </td>
              <td>
                <b-form-checkbox
                  :checked="item.promotion !== null"
                  :disabled="true"
                  v-b-tooltip :title="item.promotion ? item.promotion.title : ''">
                </b-form-checkbox>
              </td>
              <td>
                <router-link
                  v-if="ableToViewItem"
                  :to="{name: 'EXSBItemShow', params: {id: item.item['@id']}}">
                  {{ item.item.name }}
                </router-link>
                <span v-else>
                    {{ item.item.name }}
                  </span>
              </td>
              <td>
                <span v-if="!item.priceUserData">
                  {{ item.item.priceNetto }}
                </span>
                <span v-else>
                  {{ item.priceUserData.priceNetto }}
                </span>
              </td>
              <td>
                {{ item.item.vatRate.range }}
              </td>
              <td>
                <span v-if="!item.priceUserData">
                  {{ item.item.priceBrutto }}
                </span>
                <span v-else>
                  {{ item.priceUserData.priceBrutto }}
                </span>
              </td>
              <td>
                <span v-if="item.dateFrom">{{$t('global.from')}}: {{ $moment(item.dateFrom).format('YYYY-MM-DD') }} </span>
                <span v-if="item.dateTo">{{$t('global.to')}}: {{ $moment(item.dateTo).format('YYYY-MM-DD') }} </span>
              </td>
            </tr>
            </tbody>
          </table>
        </div>
      </b-card>
    </b-col>
    <b-col md="12" lg="12" v-if="item.agreementVariants.length > 0">
      <b-card>
        <h6>
          <i class="fa fa-gifts fa-lg"></i>
          {{$t('views.agreements.show.variants')}}:
        </h6>
        <template v-for="(variant) in item.agreementVariants">
          <div :key="'variantTitle' + variant['@id']">
              {{variant.title}}:
            <hr class="mb-1 mt-0">
          </div>
          <div :key="variant['@id']">
            <table class="table table-responsive-md table-sm table-grid">
              <thead>
              <tr>
                <th style="width: 5%">
                  <p>{{$t('views.exsbinvoices.form.invoicePositionHeaders.lp')}}</p>
                </th>
                <th style="width: 3%">
                  <i class="fa fa-clock fa-lg" v-b-tooltip :title="$t('buttons.cyclicItem')"></i>
                </th>
                <th style="width: 5%">
                  <i class="fa fa-percentage fa-lg" v-b-tooltip :title="$t('buttons.promotion')"></i>
                </th>
                <th style="width: 15%">
                  <p>{{$t('views.exsbinvoices.form.invoicePositionHeaders.item')}}</p>
                </th>
                <th style="width: 15%">
                  <p>{{$t('views.exsbinvoices.form.invoicePositionHeaders.valueNetto')}}</p>
                </th>
                <th style="width: 15%">
                  <p>{{$t('views.exsbinvoices.form.invoicePositionHeaders.vatRate')}}</p>
                </th>
                <th style="width: 15%">
                  <p>{{$t('views.exsbinvoices.form.invoicePositionHeaders.valueBrutto')}}</p>
                </th>
                <th style="width: 20%"></th>
              </tr>
              </thead>
              <tbody>
              <tr v-for="(item, index) in variant.variantItems" :key="'variantItems' + item['@id']">
                <td>{{ index + 1 }}</td>
                <td>
                  <b-form-checkbox
                    :checked="item.isCyclic !== 0"
                    :disabled="true">
                  </b-form-checkbox>
                </td>
                <td>
                  <b-form-checkbox
                    :checked="item.promotion !== null"
                    :disabled="true"
                    v-b-tooltip :title="item.promotion ? item.promotion.title : ''">
                  </b-form-checkbox>
                </td>
                <td>
                  <router-link
                    v-if="ableToViewItem"
                    :to="{name: 'EXSBItemShow', params: {id: item.item['@id']}}">
                    {{ item.item.name }}
                  </router-link>
                  <span v-else>
                      {{ item.item.name }}
                    </span>
                </td>
                <td>
                  <span v-if="!item.priceUserData">
                    {{ item.item.priceNetto }}
                  </span>
                  <span v-else>
                    {{ item.priceUserData.priceNetto }}
                  </span>
                </td>
                <td>
                  {{ item.item.vatRate.range }}
                </td>
                <td>
                  <span v-if="!item.priceUserData">
                    {{ item.item.priceBrutto }}
                  </span>
                  <span v-else>
                    {{ item.priceUserData.priceBrutto }}
                  </span>
                </td>
                <td>
                  <span v-if="item.dateFrom">{{$t('global.from')}}: {{ $moment(item.dateFrom).format('YYYY-MM-DD') }} </span>
                  <span v-if="item.dateTo">{{$t('global.to')}}: {{ $moment(item.dateTo).format('YYYY-MM-DD') }} </span>
                </td>
              </tr>
              </tbody>
            </table>
          </div>
          <div v-if="variant.variantAdditionalItems.length > 0" :key="'variantAdditionalItems' + variant['@id']">
            <table class="table table-responsive-md table-sm table-grid">
              <thead>
              <tr>
                <th style="width: 5%">
                  <p>{{$t('views.exsbinvoices.form.invoicePositionHeaders.lp')}}</p>
                </th>
                <th style="width: 3%">
                  <i class="fa fa-clock fa-lg" v-b-tooltip :title="$t('buttons.cyclicItem')"></i>
                </th>
                <th style="width: 5%">
                  <i class="fa fa-percentage fa-lg" v-b-tooltip :title="$t('buttons.promotion')"></i>
                </th>
                <th style="width: 15%">
                  <p>{{$t('views.exsbinvoices.form.invoicePositionHeaders.additionalItem')}}</p>
                </th>
                <th style="width: 15%">
                  <p>{{$t('views.exsbinvoices.form.invoicePositionHeaders.valueNetto')}}</p>
                </th>
                <th style="width: 15%">
                  <p>{{$t('views.exsbinvoices.form.invoicePositionHeaders.vatRate')}}</p>
                </th>
                <th style="width: 15%">
                  <p>{{$t('views.exsbinvoices.form.invoicePositionHeaders.valueBrutto')}}</p>
                </th>
                <th style="width: 20%"></th>
              </tr>
              </thead>
              <tbody>
              <tr v-for="(item, index) in variant.variantAdditionalItems" :key="item['@id']">
                <td>{{ index + 1 }}</td>
                <td>
                  <b-form-checkbox
                    :checked="item.isCyclic !== 0"
                    :disabled="true">
                  </b-form-checkbox>
                </td>
                <td>
                  <b-form-checkbox
                    :checked="item.promotion !== null"
                    :disabled="true"
                    v-b-tooltip :title="item.promotion ? item.promotion.title : ''">
                  </b-form-checkbox>
                </td>
                <td>
                  <router-link
                    v-if="ableToViewItem"
                    :to="{name: 'EXSBItemShow', params: {id: item.item['@id']}}">
                    {{ item.item.name }}
                  </router-link>
                  <span v-else>
                      {{ item.item.name }}
                    </span>
                </td>
                <td>
                  <span v-if="!item.priceUserData">
                    {{ item.item.priceNetto }}
                  </span>
                  <span v-else>
                    {{ item.priceUserData.priceNetto }}
                  </span>
                </td>
                <td>
                  {{ item.item.vatRate.range }}
                </td>
                <td>
                  <span v-if="!item.priceUserData">
                    {{ item.item.priceBrutto }}
                  </span>
                  <span v-else>
                    {{ item.priceUserData.priceBrutto }}
                  </span>
                </td>
                <td>
                  <span v-if="item.dateFrom">{{$t('global.from')}}: {{ $moment(item.dateFrom).format('YYYY-MM-DD') }} </span>
                  <span v-if="item.dateTo">{{$t('global.to')}}: {{ $moment(item.dateTo).format('YYYY-MM-DD') }} </span>
                </td>
              </tr>
              </tbody>
            </table>
          </div>
        </template>
      </b-card>
    </b-col>
    <b-col md="12" lg="6">
      <b-card>
        <div>
          <h6>
            <i class="fa fa-handshake fa-lg"></i>
            {{$t('views.agreements.form.agreementsConsents')}}:
          </h6>
          <hr class="mb-1 mt-0">
        </div>
        <div>
          <table class="table table-sm table-grid">
            <thead>
            <tr>
              <th></th>
              <th class="text-center">{{ $t('views.agreements.form.agreeRequired') }}</th>
              <th class="text-center">{{ $t('views.agreements.form.agree') }}</th>
            </tr>
            </thead>
            <tbody>
            <tr v-for="item in item.agreementsConsents" :key="item['@id']">
              <td>
                {{ item.consent.title }}
              </td>
              <td class="text-center">
                <i :class="getIcon(item.consent.requireConsent).icon" :style="'color: ' + getIcon(item.consent.requireConsent).color" v-b-tooltip.hover :title="getIcon(item.consent.requireConsent).toolTip"></i>
              </td>
              <td class="text-center">
                <i :class="getIconForAgreeConsent(item.agree).icon" :style="'color: ' + getIconForAgreeConsent(item.agree).color" v-b-tooltip.hover :title="getIconForAgreeConsent(item.agree).toolTip"></i>
              </td>
            </tr>
            </tbody>
          </table>
        </div>
      </b-card>
      <b-card v-if="item.monthlyInvoice === 1">
        <div>
          <h6>
            <i class="fa fa-cogs fa-lg"></i>
            {{$t("views.agreements.form.invoiceSettings")}}:
          </h6>
          <hr class="mb-1 mt-0">
        </div>
        <div>
          <p>
            {{ $t('views.agreements.form.autoInvoicing') + ' - ' }}
            <b v-if="item.monthlyInvoice === 1">{{ $t('global.yes') }}</b>
            <b v-else>{{ $t('global.no') }}</b>
          </p>
          <p>
            {{ $t('views.agreements.form.vatInvoice') + ' - ' }}
            <b v-if="item.vatInvoice === 1">{{ $t('global.yes') }}</b>
            <b v-else>{{ $t('global.no') }}</b>
          </p>
          <p v-if="item.idEXSBPaymentWay">
            {{ $t('views.agreements.form.idEXSBPaymentWay') + ' - ' }}
            <b>{{ item.idEXSBPaymentWay.name }}</b>
          </p>
          <p v-if="item.paymentDaysInvoice">
            {{ $t('views.agreements.form.paymentDaysInvoice') + ' - ' }}
            <b>{{ item.paymentDaysInvoice }}</b>
          </p>
          <p v-if="item.invoiceComment">
            {{ $t('views.agreements.form.invoiceComment') + ' - ' }}
            <b>{{ item.invoiceComment }}</b>
          </p>
        </div>
      </b-card>
      <b-card v-if="item.customFields && item.customFields.length > 1">
        <div>
          <h6>
            <i class="fa fa-handshake fa-lg"></i>
            {{$t('views.agreements.form.customFields')}}:
          </h6>
          <hr class="mb-1 mt-0">
        </div>
        <div>
          <table class="table table-sm table-grid">
            <thead>
            <tr>
              <th>{{$t('views.agreements.form.customField')}}</th>
              <th>{{ $t('views.agreements.form.customValue') }}</th>
            </tr>
            </thead>
            <tbody>
            <tr v-for="item in item.customFields" :key="item['@id']">
              <td>
                {{ item.field }}
              </td>
              <td>
                {{ item.value }}
              </td>
            </tr>
            </tbody>
          </table>
        </div>
      </b-card>
    </b-col>
    <b-col md="12" lg="6">
      <b-card v-if="invoices.length > 0">
        <div>
          <h6>
            <i class="fa fa-credit-card fa-lg"></i>
            {{$t('menu.invoices.list')}}:
          </h6>
          <hr class="mb-1 mt-0">
        </div>
        <div>
          <table class="table table-sm table-responsive-md table-striped table-hover">
            <thead>
            <tr>
              <th>{{ $t('views.exsbinvoices.form.number') }}</th>
              <th>{{ $t('views.exsbinvoices.list.sellDate') }}</th>
              <th>{{ $t('views.exsbinvoices.list.paymentDeadline') }}</th>
              <th>{{ $t('views.exsbinvoices.list.totalValueBrutto') }}</th>
              <th>{{ $t('views.exsbinvoices.list.totalValueNetto') }}</th>
              <th>{{$t('menu.exsbpaymentsmade.index')}}</th>
            </tr>
            </thead>
            <tbody>
            <tr v-for="item in invoices" :key="item['@id']">
              <td>
                <router-link
                  v-if="ableToViewInvoices"
                  :to="{name: 'EXSBInvoiceShow', params: {id: item['@id']}}">
                  {{item.number || $t('views.agreements.list.noNumber')}}
                </router-link>
                <span v-else>{{ item.number }}</span>
              </td>
              <td>
                {{ $moment(item['sellDate']).format('YYYY-MM-DD') }}
              </td>
              <td>
                {{ $moment(item['paymentDeadline']).format('YYYY-MM-DD') }}
              </td>
              <td>
                {{ item['totalValueBrutto'] }}
              </td>
              <td>
                {{ item['totalValueNetto'] }}
              </td>
              <td>
                <ul class="mb-0" v-if="item.paymentsMade.length > 0">
                  <li v-for="item in item.paymentsMade" :key="item['@id']">
                    <router-link :to="{name: 'EXSBPaymentsMadeUpdate', params: {id: item['@id']}}">
                      <b>{{ item.value }} {{$t('currency')}} - {{ $moment(item.paymentDate).format('YYYY-MM-DD HH:mm') }}</b>
                    </router-link>
                  </li>
                </ul>
              </td>
            </tr>
            </tbody>
          </table>
        </div>
      </b-card>
    </b-col>
    <b-col v-if="item.type === 1 && agreementsFromOffer.length > 0" md="12" lg="12">
      <b-card>
        <div>
          <h6>
            <i class="fa fa-handshake fa-lg"></i>
            {{$t('views.agreements.show.agreementsFromOffer')}}:
          </h6>
          <hr class="mb-1 mt-0">
        </div>
        <div>
          <table class="table table-responsive-md table-sm table-grid">
            <thead>
            <tr>
              <th style="width: 2%">
                <p>{{$t('views.exsbinvoices.form.invoicePositionHeaders.lp')}}</p>
              </th>
              <th style="width: 12%">
                <p>{{$t('views.agreements.list.agreementNumber')}}</p>
              </th>
              <th style="width: 10%">
                <p>{{$t('views.exsbitems.list.basePrice')}}</p>
              </th>
              <th style="width: 10%">
                <p>{{$t('views.exsbitems.list.customPrice')}}</p>
              </th>
              <th style="width: 10%">
                <p>{{$t('views.exsbitems.list.advantageValue')}}</p>
              </th>
            </tr>
            </thead>
            <tbody>
            <tr v-for="(item, index) in agreementsFromOffer" :key="item['@id']">
              <td>{{ index + 1 }}</td>
              <td>
                <router-link
                  :to="{name: 'EXABAgreementShow', params: {id: item['@id']}}">
                  {{ item.number }}
                </router-link>
              </td>
              <td><span v-if="item.basePrice">{{item.basePrice}}</span></td>
              <td><span v-if="item.customPrice">{{item.customPrice}}</span></td>
              <td><span v-if="item.advantageValue">{{item.advantageValue}}</span></td>
            </tr>
            </tbody>
          </table>
        </div>
      </b-card>
    </b-col>
    <b-col md="12" lg="12">
      <b-card>
        <div>
          <h6>
            <i class="fa fa-chart-line fa-lg"></i>
            {{$t('views.agreements.show.ageOfReceivables')}}
            <button v-if="ageingOfReceivablesVisible === false" aria-controls="ageing_of_receivables_collapse" class="btn btn-sm" @click="ageingOfReceivablesVisible = true" type="button"> {{ $t('buttons.expand') }} </button>
            <button v-else aria-controls="ageing_of_receivables_collapse" class="btn btn-sm" @click="ageingOfReceivablesVisible = false" type="button"> {{ $t('buttons.fold') }} </button>
          </h6>
          <b-collapse id="ageing_of_receivables_collapse" v-model="ageingOfReceivablesVisible">
            <hr class="mb-1 mt-0">
            <AgeingOfReceivables :id-agreement="$route.params.id"/>
          </b-collapse>
        </div>
      </b-card>
    </b-col>
  </b-row>
  <AgreementPreviewHTMLModal></AgreementPreviewHTMLModal>
</div>
</template>

<script>
import { mapGetters, mapActions, mapMutations } from 'vuex'
import Loader from '@/components/Dashboard/Layout/Loader'
import addParamsToQuery from '@/utils/addParamsToQuery'
import getId from '@/utils/getIdFromLink'
import { checkPermission } from '@/utils/checkRoles'
import AgreementPreviewHTMLModal from '@/components/Dashboard/Views/AgreementsBundle/agreements/components/modals/AgreementPreviewHTMLModal'
import ApiService from '@/utils/ApiService'
import moment from 'moment'
import AgeingOfReceivables from '@/components/Dashboard/Views/AgreementsBundle/agreements/AgeingOfReceivables'
import PhoneNumberLink from '@/components/Dashboard/Views/firm/components/PhoneNumberLink'

export default {
  name: 'Show',
  components: { PhoneNumberLink, AgeingOfReceivables, Loader, AgreementPreviewHTMLModal },

  data () {
    return {
      moment,
      decision: {},
      loadingDecision: true,
      TYPE_INPUT: 1,
      TYPE_LABEL: 2,
      TYPE_DATE: 3,
      TYPE_SELECT: 4,
      agreementsFromOffer: [],
      ageingOfReceivablesVisible: false
    }
  },

  computed: {
    ...mapGetters({
      item: 'agreements/show/getAgreement',
      isLoading: 'agreements/show/getIsLoadingAgreement',
      invoices: 'exsbinvoice/list/items',
      addressTypeOptions: 'userdataaddress/list/addressTypeOptions',
      getAddressTypeText: 'userdataaddress/list/getAddressTypeText'
    }),
    ableToViewDevice () {
      return checkPermission('devices', 'EXCMDeviceShow')
    },
    ableToViewInvoices () {
      return checkPermission('finances', 'EXSBInvoiceShow')
    },
    ableToViewItem () {
      return checkPermission('warehouses', 'EXSBItemShow')
    }
  },

  beforeCreate () {
    // checkPagePermission('exabagreements', 'EXABAgreementShow')
  },

  watch: {
    '$route.params' () {
      this.fetchAgreement(this.$route.params.id)
      this.fetchAgreementsFromOffer(this.$route.params.id)
      this.fetchPayments()
    },
    isLoading (val) {
      if (!val) this.fetchDecisionData(this.$route.params.id)
    }
  },

  created () {
    this.fetchAgreement(this.$route.params.id)
    this.fetchAgreementsFromOffer(this.$route.params.id)
    this.fetchPayments()
  },

  beforeDestroy () {
    this.reset()
  },

  methods: {
    // getAddressTypeTitle (id) {
    //   return this.addressTypeOptions.find(entry => entry.value === id).text
    // },
    showPreviewModal () {
      this.toggleAgreementPreviewHTMLModal()
      this.setAgreementId(this.$route.params.id)
      this.fetchAgreementAsPDF()
    },
    fetchPayments () {
      let route = 'e_x_s_b_invoices'
      let link = addParamsToQuery(route, { idAgreement: getId(this.$route.params.id) })
      this.getInvoices(link)
    },
    async fetchAgreementsFromOffer (id) {
      let params = { agreementOffer: id, pagination: false }
      const response = await new ApiService('e_x_a_b_agreements', params).getResults()
      this.agreementsFromOffer = response.items
    },
    async fetchDecisionData (id) {
      const response = await new ApiService(id + '/getagreementsigningstatus').getResults()
      let decisionUser = this.item.decisionUser
      if (decisionUser === 0) {
        this.decision.decision = this.$t('views.agreements.show.propositionAgreementsOffers')
      } else if (decisionUser === 1) {
        this.decision.decision = this.$t('views.agreements.show.noDecisionAgreementsOffers')
      } else if (decisionUser === 2) {
        this.decision.decision = this.$t('views.agreements.show.rejectedAgreementsOffers')
      } else if (decisionUser === 3) {
        this.decision.decision = this.$t('views.agreements.show.acceptedAgreementsOffers')
      } else if (decisionUser === 4) {
        this.decision.decision = this.$t('views.agreements.show.acceptedWithCommentsAgreementsOffers')
      } else if (decisionUser === 5) {
        if (this.item.status === '3' || this.item.status === '5') {
          this.decision.decision = this.$t('views.agreements.show.signedAgreement')
        } else if (response) {
          this.decision.decision = this.$t('views.agreements.show.pendingSms')
        } else {
          this.decision.decision = this.$t('views.agreements.show.acceptedAgreementsOffers')
        }
        if (response) {
          this.decision.signedBy = response.signedBy
          this.decision.confirmationPhone = response.confirmationPhone
          this.decision.confirmationPin = response.confirmationPin
          this.decision.messageNumber = response.messageNumber
          this.decision.clientIp = response.clientIp
          this.decision.signedDate = response.signedDate
          if (response.sendMessageDate) {
            this.decision.sendMessageDate = this.moment(response.sendMessageDate.date).format('YYYY-MM-DD HH:mm')
          }
          if (response.signedDate) {
            this.decision.signedDate = this.moment(response.signedDate.date).format('YYYY-MM-DD HH:mm')
          }
          this.decision.isSigned = response.signedDate
        }
      }
      if (this.item.decisionDate) {
        this.decision.decision += ' - ' + this.moment(this.item.decisionDate.date).format('YYYY-MM-DD HH:mm')
      }
      this.loadingDecision = false
    },
    getIcon (num) {
      if (num === 1) {
        return { icon: 'fa fa-check-circle fa-lg', color: '#28a745', toolTip: this.$t('buttons.yes') }
      } else {
        return { icon: 'fa fa-times-circle fa-lg', color: '#dc3545', toolTip: this.$t('buttons.no') }
      }
    },
    getIconForAgreeConsent (num) {
      if (num === 2) {
        return { icon: 'fa fa-check-circle fa-lg', color: '#28a745', toolTip: this.$t('buttons.yes') }
      } else if (num === 1) {
        return { icon: 'fa fa-times-circle fa-lg', color: '#dc3545', toolTip: this.$t('buttons.no') }
      } else {
        return { icon: 'fa fa-times-circle fa-lg', color: '#cccccc', toolTip: this.$t('views.agreements.show.noDecision') }
      }
    },
    downloadAgreementSignedCertificate () {
      new ApiService(this.item['@id'] + '/get_signedcertificate_pdf').downloadFile('signedCertificate.pdf')
    },
    ...mapActions({
      fetchAgreement: 'agreements/show/fetchAgreement',
      getInvoices: 'exsbinvoice/list/getItems',
      fetchAgreementAsPDF: 'agreements/previewModal/fetchAgreementAsPDF'
    }),
    ...mapMutations({
      reset: 'agreements/show/reset',
      toggleAgreementPreviewHTMLModal: 'agreements/previewModal/toggleAgreementPreviewHTMLModal',
      setAgreementId: 'agreements/previewModal/setAgreementId'
    })
  }
}
</script>

<style scoped>

</style>
